import round from 'utils/round';

export default function (seconds) {
  const mins = seconds / 60;
  return mins > 60
    ? `${Math.floor(mins / 60)} hours ${round(mins % 60)} mins`
    : `${round(mins)} mins`;
}
